"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNothing = exports.isRenderNothing = void 0;
var nonce = {};
var isRenderNothing = function (value) { return value === nonce; };
exports.isRenderNothing = isRenderNothing;
var renderNothing = function () { return function (_props) { return nonce; }; };
exports.renderNothing = renderNothing;
var renderNothingPublishedType = exports.renderNothing;
exports.default = renderNothingPublishedType;
